'use client';

import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Avatar, Divider, ScrollArea, Stack, Text } from '@mantine/core';
import { useCurrentAgency } from '@/queries/agencies/useCurrentAgency';
import { useClients } from '@/queries/clients/useClients';
import { useMe } from '@/queries/me/useMe';
import { getClientImageUrl } from '@/utils/file';
import { NavbarButton } from './NavbarButton';

export const ClientList = observer(function ClientList() {
  const { t } = useTranslation();
  const { data: me } = useMe();
  const { data: clientsData } = useClients();
  const { data: agency } = useCurrentAgency();
  // const isCompetitorsEnabled = useFlag(Flags.Competitors, false);
  // const isPreviewEnabled = useFlag(Flags.Preview, false);

  const favorites = me?.favoriteClientIds ?? [];
  const isClientUser = agency?.role === 'client';

  const clients = clientsData?.data.clients ?? [];

  const favoriteClients = clients.filter(
    (client) => favorites.includes(client.id) && !client.archived
  );
  const otherClients = clients.filter(
    (client) => !favorites.includes(client.id) && !client.archived
  );

  if (!clients.length) {
    return null;
  }

  return (
    <Stack gap={0} py="3xs" h="100%" style={{ overflowY: 'auto' }} pb="xl">
      <Text size="xs" px="sm" c="dimmed" fw={400}>
        {t('clients.clients')}
      </Text>
      <ScrollArea.Autosize mah="100%">
        {favoriteClients.map((client) => (
          <NavbarButton
            key={client.id}
            href={isClientUser ? `/client-area/${client.id}` : `/client/${client.id}`}
            exact={false}
            icon={
              <Avatar
                size={14}
                radius="lg"
                src={client.image ? getClientImageUrl(client.id) : undefined}
                name={client.name}
                color="initials"
              />
            }
            label={client.name}
          />
        ))}
        {favoriteClients.length > 0 && otherClients.length > 0 && <Divider my="xs" />}
        {otherClients.map((client) => (
          <NavbarButton
            key={client.id}
            href={isClientUser ? `/client-area/${client.id}` : `/client/${client.id}`}
            exact={false}
            icon={
              <Avatar
                size={14}
                radius="lg"
                src={client.image ? getClientImageUrl(client.id) : undefined}
                name={client.name}
                color="initials"
              />
            }
            label={client.name}
          />
        ))}
      </ScrollArea.Autosize>
    </Stack>
  );
});
